import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterTendancePictoProps extends pictoProps {
}

export interface FooterTendancePictoState extends pictoState {
}

export class FooterTendancePicto extends Picto<FooterTendancePictoProps,FooterTendancePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerTendancePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterTendancePicto);
